import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-admin-electable-committees-add',
  templateUrl: './admin-electable-committees-add.component.html',
  styleUrls: ['./admin-electable-committees-add.component.css']
})
export class AdminElectableCommitteesAddComponent implements OnInit {
  @Input() committees;
  @Input() institutions;
  @Input() institutiontypes;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  

  constructor(
    private fb: FormBuilder) { }

    ngOnInit(): void {
      this.form = this.fb.group({
        type: ['', Validators.required],
        committeeId: ['', ''],
        institutionId: ['', ''],
        institutionTypeId: ['', '']
      });
    }
  cancel() {
    this.doCancel.emit();
  }

  save() {
    this.doSave.emit(this.form.value);
    this.form.reset();
  }

  setCommittee(evt) {
    this.form.patchValue({ committeeId: evt.value });
  }

  setInstitution(evt) {
    this.form.patchValue({ institutionId: evt.value });
  }

  setInstitutionType(evt) {
    this.form.patchValue({ institutionTypeId: evt.value });
  }

  clearForm(evt) {
    const type = evt.value;
    this.form.reset();
    this.form.patchValue({ type: type });
  }

}
